// Capture, carry, and consume a plan+period intent across auth/onboarding flows.
// Survives login → OTP → onboarding → reload chains via localStorage (cookies & query strings don't).

const STORAGE_KEY = 'pending_subscription_intent';
const TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export const capturePendingSubscriptionIntent = () => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const planType = params.get('plan_type');
  const billingPeriod = params.get('billing_period');

  // No plan in the URL → nothing to capture.
  if (!planType) return;

  const intent = {
    planType,
    billingPeriod: billingPeriod || 'monthly', // Default to monthly if not specified.
    capturedAt: Date.now(),
  };

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(intent));
  } catch (e) {
    // localStorage full or unavailable; fail soft, no crash.
    console.warn('Failed to capture subscription intent:', e);
  }
};

export const readPendingSubscriptionIntent = () => {
  if (typeof localStorage === 'undefined') return null;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;

    const intent = JSON.parse(stored);
    const age = Date.now() - intent.capturedAt;

    // Expired → clear and return null.
    if (age > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return intent;
  } catch (e) {
    // Corrupted data → clear and return null.
    console.warn('Failed to read subscription intent:', e);
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

export const clearPendingSubscriptionIntent = () => {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // Safe to ignore on clear.
  }
};

export const hasPendingSubscriptionIntent = () => {
  return readPendingSubscriptionIntent() !== null;
};
